import { INotification } from '../models/notification'
import { BaseUrl } from './base_url_enum'
import { IApiResponse } from './index'
import Api from './index'

type INotificationsApiResponse = {
  inboxMessages: INotification[]
  message?: string
}

type INotificationApiResponse = {
  inboxMessage: INotification
  message?: string
}

export const getNotifications = (relationNumber: number) => Api<IApiResponse<INotificationsApiResponse>>('GET', `inbox-messages?relation_number=${relationNumber}`, BaseUrl.Content, undefined, true)

export const getNotification = (relationNumber: number, id: string) => Api<IApiResponse<INotificationApiResponse>>('GET', `inbox-messages/${id}?relation_number=${relationNumber}`, BaseUrl.Content)

export const deleteNotification = (relationNumber: number, id: number) => Api<IApiResponse<INotificationApiResponse>>('DELETE', `inbox-messages/${id}?relation_number=${relationNumber}`, BaseUrl.Content)

export const putNotification = (relationNumber: number, id: number) => Api<IApiResponse<INotificationApiResponse>>('PUT', `inbox-messages/${id}?relation_number=${relationNumber}`, BaseUrl.Content)
